import { all } from 'redux-saga/effects';

import imprimirRenachSaga from './renach/saga';

export default all([imprimirRenachSaga]);
